/*
* (c) W3Cms
* */
const styles = ['font-size: 14px', 'color: #ffffff', 'background-color: #7FA113', 'padding: 4px 0px 4px 8px'].join(';')
    , brandStyles = ['font-size: 14px', 'color: #ffffff', 'background-color: #293133', 'padding: 4px 8px 4px 8px', 'font-weight: bold'].join(';')
    , text = '%cMade by %cW3design https://www.w3design.it/';
console.log(text, styles, brandStyles);

import $ from "jquery";
window.$ = $;
window.jQuery = $;

$(document).ready(function(){
    $('.gotoSection').click(function(e){
        e.preventDefault();
        if(!$('#menu-button').is('.collapsed')) {
            $('.hamburger').trigger('click');
        }
        let position = $(this).attr('href');
        $("html, body").animate({scrollTop:$(position).offset().top}, 'slow');
        $('.navigation').removeClass('show');
    })

    let lang_site = $('#departure_date').data('lang');
    flatpickr('#departure_date', {
        locale: lang_site,
        minDate: 'today',
        dateFormat: 'd/m/Y',
        disableMobile: true
    });

    /*flatpickr('#departure_time', {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
        disableMobile: true
    });

    flatpickr('#arrival_time', {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
        disableMobile: true
    });*/
});


class TimePicker {
    constructor(inputId, options = {}) {
        this.input = document.getElementById(inputId);
        this.dropdown = document.getElementById(inputId + '-picker');
        this.step = options.step || 15;
        this.minTime = options.minTime || '00:00';
        this.maxTime = options.maxTime || '23:59';
        this.onChange = options.onChange || function() {};
        this.defaultToNow = options.defaultToNow ?? true; // default true

        this.buildDropdown();
        this.bindEvents();
    }

    timeToMinutes(time) {
        const [h, m] = time.split(':').map(Number);
        return h * 60 + m;
    }

    minutesToTime(mins) {
        const h = Math.floor(mins / 60);
        const m = mins % 60;
        return `${h.toString().padStart(2,'0')}:${m.toString().padStart(2,'0')}`;
    }

    buildDropdown() {
        const minMins = this.timeToMinutes(this.minTime);
        const maxMins = this.timeToMinutes(this.maxTime);
        this.dropdown.innerHTML = '';

        for (let m = minMins; m <= maxMins; m += this.step) {
            const time = this.minutesToTime(m);
            const div = document.createElement('div');
            div.textContent = time;

            div.addEventListener('click', () => {
                this.input.value = time;
                this.highlightSelected();
                this.dropdown.style.display = 'none';
                this.onChange(time);
            });

            this.dropdown.appendChild(div);
        }
    }

    highlightSelected() {
        Array.from(this.dropdown.children).forEach(div => {
            div.classList.toggle('selected', div.textContent === this.input.value);
        });
    }

    bindEvents() {
        this.input.addEventListener('focus', () => {
            const rect = this.input.getBoundingClientRect();
            this.dropdown.style.top = rect.bottom + window.scrollY + 'px';
            this.dropdown.style.left = rect.left + window.scrollX + 'px';
            this.dropdown.style.width = rect.width + 'px';
            this.dropdown.style.display = 'block';

            // default ora corrente solo se defaultToNow = true
            if (!this.input.value && this.defaultToNow) {
                const now = new Date();
                const minutes = now.getHours() * 60 + now.getMinutes();
                const closest = Math.round(minutes / this.step) * this.step;
                this.input.value = this.minutesToTime(closest);
            }

            this.highlightSelected();

            // scroll automatico alla selezione
            const selected = Array.from(this.dropdown.children)
                .find(div => div.textContent === this.input.value);
            if (selected) selected.scrollIntoView({ block: 'nearest' });
        });

        document.addEventListener('click', e => {
            if (!this.input.contains(e.target) && !this.dropdown.contains(e.target)) {
                this.dropdown.style.display = 'none';
            }
        });
    }
}

// Inizializzazione
new TimePicker('departure_time', {
    step: 15,
    minTime: '00:00',
    maxTime: '23:59',
    defaultToNow: true,
    onChange: value => console.log('Partenza:', value)
});

new TimePicker('arrival_time', {
    step: 15,
    minTime: '00:00',
    maxTime: '23:59',
    defaultToNow: false,
    onChange: value => console.log('Arrivo:', value)
});



